import React from 'react';
import TimeSeriesChart from './TimeSeriesChart';
import TimeSeriesRender from './TimeSeriesRender';
import TimeSeriesAnimation from './TimeSeriesAnimation';

const TimeSeries = ({
    mapRef, tscCoords, tscModeRef, isButtonClicked, setMapParameters, fetchCommonDates, setEnabledDates, setIsButtonClicked, setStartDate, layerRefs, setIsDatePickerDisabled, isDatePickerDisabled
}) => {

    if (isButtonClicked.tsc) {

        return (
            <TimeSeriesChart
                tscCoords={tscCoords}
                mapRef={mapRef}
                setIsTSCButtonClicked={setIsButtonClicked.tsc}
                tscModeRef={tscModeRef}
            />
        )

    }

    if (isButtonClicked.tsr) {

        return (
            <TimeSeriesRender
                mapRef={mapRef}
                setIsTSRButtonClicked={setIsButtonClicked.tsr}
                setStartDate={setStartDate}
                layerRefs={layerRefs}
                setMapParameters={setMapParameters}
                fetchCommonDates={fetchCommonDates}
                setEnabledDates={setEnabledDates}
                isDatePickerDisabled={isDatePickerDisabled}
                setIsDatePickerDisabled={setIsDatePickerDisabled}
            />
        );

    }

    if (isButtonClicked.tsa) {

        return (
            <TimeSeriesAnimation
                mapRef={mapRef}
                setIsTSAButtonClicked={setIsButtonClicked.tsa}
            />
        );

    }
}

export default TimeSeries;